import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MaterialModule } from '../material/material.module';
import { FeesSummaryComparisonComponent } from './fees-summary-comparison.component';

@NgModule({
    declarations: [FeesSummaryComparisonComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MaterialModule
    ],
    exports: [FeesSummaryComparisonComponent]
})
export class FeesSummaryComparisonModule { }